import { createAsyncThunk } from "@reduxjs/toolkit";
import { PatchVouchersChangeStatusParams } from "api/api/vouchersApi/types";
import { VouchersAPI } from "api/api/vouchersApi/vouchersApi";
import axios from "axios";

export const patchVouchersChangeStatus = createAsyncThunk<
  void,
  PatchVouchersChangeStatusParams
>(
  "vouchers/patchVouchersChangeStatus",
  async ({ voucherId, ...params }, { rejectWithValue }) => {
    try {
      await VouchersAPI.patchVouchersChangeStatus({ voucherId, ...params });
    } catch (error: unknown) {
      if (axios.isAxiosError(error)) {
        console.error(
          "Error while patching voucher status",
          error.response?.data
        );
        return rejectWithValue(error.response?.data || "Unknown error");
      } else {
        console.error("Error while patching voucher status", error);
        return rejectWithValue(
          "Что-то пошло не так... Попробуйте обновить страницу"
        );
      }
    }
  }
);
